export const UNIT_INDICATORS = ['apt', 'unit', 'ste', 'suite', '#'];
